import { app } from '../../app';

app.factory('SamlLoginHandler', SamlLoginHandler);

/** @ngInject */
function SamlLoginHandler($rootScope, $location, $state, SamlService) {

    return {
        login : function(username, password, il, pl, captchaResponse, errorCallback) { 
            $rootScope.authenticationError = false;
            var appKey = $state.params.applicationId;
//            if(!il && pl) {
//            	SamlService.getSPWebSamlData.save({appKey: appKey,captchaResponse : captchaResponse,},{username: username, password:password}, function(data) {
//            		proccessLoginResponce(data);
//            		}, function(error) {       
//                        processLoginError(error,  errorCallback);
//                    });
//            	
//            } else {
            SamlService.getSPWebSamlData.save({
                SAMLTracker: $location.search().SAMLTracker,
                appKey : appKey,
                captchaResponse : captchaResponse,
                il : il,
                pl : pl
            },{username: username, password:password}, function(data) {
            	proccessLoginResponce(data);
    		}, function(error) {       
                processLoginError(error,  errorCallback);
            });
            //};
        },
        passwordLogin : function(username, password, il, pl, captchaResponse, errorCallback) {
            $rootScope.authenticationError = false;
            var appKey = $state.params.applicationId;
            SamlService.getSPWebSamlData.save({
                SAMLTracker: $location.search().SAMLTracker,
                appKey : appKey,
                captchaResponse : captchaResponse,
                il : il,
                pl : pl
            },{username : username, password : password}, function(data) {

                var form = document.createElement("form");
                form.setAttribute('method',"post");

                var i;
                if(null != data.samlResponse) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "SAMLResponse");
                    i.setAttribute('value', data.samlResponse);
                    form.appendChild(i);
                }

                if(null !=data.relayState) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "RelayState");
                    i.setAttribute('value', data.relayState);
                    form.appendChild(i);
                }

                if(null != data.wtrealm){
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"wresult");
                    i.setAttribute('value',data.wtrealm);
                    form.appendChild(i);
                }

                if(null != data.wctx){
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"wctx");
                    i.setAttribute('value',data.wctx);
                    form.appendChild(i);
                }

                if(null != data.wa){
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"wa");
                    i.setAttribute('value',data.wa);
                    form.appendChild(i);
                }

                if(null != data.casLt){
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"lt");
                    i.setAttribute('value',data.casLt);
                    form.appendChild(i);
                }

                if (null != data.casExecution) {
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"execution");
                    i.setAttribute('value',data.casExecution);
                    form.appendChild(i);
                }

                if (null != data.casEventId) {
                    i = document.createElement("input");
                    i.setAttribute('type',"hidden");
                    i.setAttribute('name',"_eventId");
                    i.setAttribute('value',data.casEventId);
                    form.appendChild(i);
                }
                if (data.saaspassPasswordExpired){
                    form.setAttribute('action', `/resetpwd/${data.redirectionLink}`);
                    document.body.appendChild(form);
                }
                else{
                    form.setAttribute('action', data.redirectionLink);
                    document.body.appendChild(form);
                }
                localStorage.setItem('loginAttempts', 0);
                form.submit();
            }, function(error) {
                const loginAttempts = +localStorage.getItem('loginAttempts') || 0;
                localStorage.setItem('loginAttempts', loginAttempts + 1);
                errorCallback(error);
            });
        }
    }
}

 function proccessLoginResponce(data) {

    var form = document.createElement("form");
    form.setAttribute('method',"post");
    
    var i;
    if(null != data.samlResponse) {
        i = document.createElement("input");
        i.setAttribute('type', "hidden");
        i.setAttribute('name', "SAMLResponse");
        i.setAttribute('value', data.samlResponse);
        form.appendChild(i);
    }

    if(null !=data.relayState) {
        i = document.createElement("input");
        i.setAttribute('type', "hidden");
        i.setAttribute('name', "RelayState");
        i.setAttribute('value', data.relayState);
        form.appendChild(i);
    }

    if(null != data.wtrealm){
        i = document.createElement("input");
        i.setAttribute('type',"hidden");
        i.setAttribute('name',"wresult");
        i.setAttribute('value',data.wtrealm);
        form.appendChild(i);
    }

    if(null != data.wctx){
        i = document.createElement("input");
        i.setAttribute('type',"hidden");
        i.setAttribute('name',"wctx");
        i.setAttribute('value',data.wctx);
        form.appendChild(i);
    }

    if(null != data.wa){
        i = document.createElement("input");
        i.setAttribute('type',"hidden");
        i.setAttribute('name',"wa");
        i.setAttribute('value',data.wa);
        form.appendChild(i);
    }

    if(null != data.casLt){
        i = document.createElement("input");
        i.setAttribute('type',"hidden");
        i.setAttribute('name',"lt");
        i.setAttribute('value',data.casLt);
        form.appendChild(i);
    }
    
    if (null != data.casExecution) {
        i = document.createElement("input");
        i.setAttribute('type',"hidden");
        i.setAttribute('name',"execution");
        i.setAttribute('value',data.casExecution);
        form.appendChild(i);
    }
    
    if (null != data.casEventId) {
        i = document.createElement("input");
        i.setAttribute('type',"hidden");
        i.setAttribute('name',"_eventId");
        i.setAttribute('value',data.casEventId);
        form.appendChild(i);
    }

    if (data.saaspassPasswordExpired){
        $state.go('public.reset-password-verify',{appKey:appKey,rkey:data.redirectionLink,appName:$state.params.appName,username:username,autoRedirect:'page'});
    }
    else{
        form.setAttribute('action', data.redirectionLink);
        document.body.appendChild(form);
    }
    localStorage.setItem('loginAttempts', 0);
    form.submit();
}
 
 
 function processLoginError(error,  errorCallback) {
	   const loginAttempts = +localStorage.getItem('loginAttempts') || 0;
       localStorage.setItem('loginAttempts', loginAttempts + 1);
       errorCallback(error);
 }



// WEBPACK FOOTER //
// ./src/portal/states/public/saml-login-handler.service.js